import React, { useContext } from 'react'
import { IonAccordion, IonAccordionGroup, IonContent, IonItem, IonPage, useIonViewWillEnter } from '@ionic/react'
import { CustomSpacer, StyleIonHeader, TextStyle } from '../../../components'
import styled from 'styled-components'
import { StoresContext } from '../../../provider/StoreProvider'
import { RouteComponentProps } from 'react-router'

export const Faq: React.FC<RouteComponentProps> = () => {
  const { commonStore } = useContext(StoresContext)

  useIonViewWillEnter(() => {
    commonStore.setShowTab(false)
  })

  return (
    <IonPage>
      <StyleIonHeader type={'SUB'} title={'FAQ'} href={'/myPage'} />
      <IonContent>
        <CustomSpacer spacing={'24px'} />
        <IonAccordionGroup>
          {FaqData.list.map((d, i) => (
            <IonAccordion key={i} value={String(i)}>
              <StyleIonItem slot="header">
                <TitleContainer>
                  <TextStyle type={'b_16'} color={'secondary_main'}>
                    {d.num}
                  </TextStyle>
                  <TextStyle type={'r_15'}>{d.title}</TextStyle>
                </TitleContainer>
              </StyleIonItem>
              <ContentContainer slot="content">
                <BoxContainer>
                  <TextStyle type={'r_13'}>{d.content}</TextStyle>
                </BoxContainer>
              </ContentContainer>
            </IonAccordion>
          ))}
        </IonAccordionGroup>
      </IonContent>
    </IonPage>
  )
}

const StyleIonItem = styled(IonItem)`
  padding: 0 4px;
`
const TitleContainer = styled.div`
  padding: 24px 0 16px;
  display: flex;
  flex-direction: column;
`
const ContentContainer = styled.div`
  padding: 0 20px 16px;
`

const BoxContainer = styled.div`
  background-color: var(--ion-color-gray100);
  border-radius: 4px;
  padding: 16px;
`

const FaqData = {
  list: [
    {
      num: 'Q1',
      title: '000플랫폼은 어떤 서비스인가요?',
      content:
        '000플랫폼은 고가의 미술품을 소액으로도 소유할 수 있는 새로운 공동 소유 플랫폼으로 미술품을 분할하여 공동 구매를 진행하며, 블록체인을 통해 작품 소유를 증명할 수 있는 플랫폼 서비스 입니다.',
    },
    {
      num: 'Q2',
      title: '조각투자 구매 수수료가 있나요?',
      content:
        '현재 진행중인 조각투자 참여시 별도의 수수료는 부과되지 않습니다. 다만 추후 관련 수수료가 변경될 가능성은 있으며, 변경시 공지사항을 통해 확인해주시기바랍니다.',
    },
    {
      num: 'Q3',
      title: '예치금 출금 계좌를 변경하고 싶어요.',
      content: `출금 계좌 변경을 원하실 경우 '마이페이지 > 설정 > 예치금 출금계좌 변경' 에서 처리 가능합니다.`,
    },
    {
      num: 'Q4',
      title: '원금이 보장되나요?',
      content:
        '미술품의 성격 및 시장 가격에 따라 시세가 변동되므로 공동구매가와 판매가가 상이할 수 있어 원금은 보장되지 않습니다.',
    },
    {
      num: 'Q5',
      title: '작품 매각시 명시된 세금은 무엇인가요?',
      content:
        '매각금액 6천만원 이상의 미술품은 양도세 부과대상으로 6천만원을 초과하는 금액에 대해 22%(VAT포함)의 과세가 적용됩니다. 세금은 기타소득 양도세법에 의해 산출되며, 구간별 금액은 상이할 수 있는 점 참고부탁드립니다.',
    },
  ],
}
